(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsDetailController', TabFleetsDetailController);

    TabFleetsDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function TabFleetsDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.tabFleets = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabFleetsUpdate', function(event, result) {
            vm.tabFleets = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
